import { client } from 'axiosClient'
import { ComposedAjaxError } from 'axiosClient/ErrorComposer'
import { UserSearchRequestBody, approveRejectRequestBody, delegateRequestBody } from './types'
import { constructSearchBody } from '../context/converters'
import { SearchRequestResponse } from '../context/types'

export const approveRequest = async (body: approveRejectRequestBody) => {
    try {
        await client.post('api/users/approve', body)
    } catch (error: any) {
        ComposedAjaxError.handleError('Error approving request', error)
    }
}
export const rejectRequest = async (body: approveRejectRequestBody) => {
    try {
        await client.post('api/users/reject', body)
    } catch (error: any) {
        ComposedAjaxError.handleError('Error rejecting request', error)
    }
}
export const delegateRequest = async (body: delegateRequestBody) => {
    try {
        await client.post('api/users/delegate', body)
    } catch (error: any) {
        ComposedAjaxError.handleError('Error delegating request', error)
    }
}

export const fetchApproveRequests = async (
    body: UserSearchRequestBody
): Promise<SearchRequestResponse | undefined> => {
    try {
        const response = await client.post('api/users/search-approves', body)
        return { data: response.data, total: response.total }
    } catch (error: any) {
        ComposedAjaxError.handleError('Error searching approve requests', error)
    }
}

export const searchApproveRequests = async (input?: string) => {
    const result = await fetchApproveRequests(
        constructSearchBody({
            competencies: [],
            searchString: input || '',
            newLevels: [],
            orderBy: null,
            offset: 0,
        })
    )
    return result?.data
}
